
import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzIconModule } from 'ng-zorro-antd/icon';

declare const turnstile: any; // Declare turnstile globally
@Component({
	selector: 'app-sign-in',
	standalone: true,
	imports: [CommonModule, FormsModule, NzButtonModule, NzModalModule, NzIconModule],
	templateUrl: './sign-in.component.html',
	styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit {
	username: string | undefined = '';
	password: string | undefined = '';
	showFailed = false;
	error: string | undefined;
	isLoading = false;
	showPassword = false;

	isOtpMode = false;
    otpCode: string | undefined = '';
	showOtp = false;

	constructor(
		private authService: AuthService,
		private toastr: ToastrService,
		// private cloudflareService: HttpCloudflareService,
	) { 
	}

	ngOnInit(): void {
		this.username = '';
		this.password = '';
		this.otpCode = '';
        this.isOtpMode = false;
	}

	togglePasswordVisibility() {
        this.showPassword = !this.showPassword;
    }

	// ngAfterViewInit() {
	// 	if (!environment.turnstile.use) {
	// 		return;
	// 	}
	// 	// Ensure the script is loaded before calling turnstile
	// 	if (typeof turnstile !== 'undefined') {
	// 		this.renderTurnstile();
	// 	} else {
	// 		// Wait for the script to load
	// 		window.onload = () => {
	// 			this.renderTurnstile();
	// 		};
	// 	}
	// }

	// renderTurnstile() {
	// 	turnstile.render('#turnstile-widget', {
	// 		sitekey: this.siteKey,
	// 		callback: (token: string) => {
	// 			this.turnstileToken = token; // Store the token
	// 			console.log('Turnstile token:', token);
	// 			// call backend to verify token
	// 			this.verifyToken();
	// 		},
	// 		'error-callback': (errorCode: string) => {
	// 			console.error('Turnstile error:', errorCode);
	// 			this.turnstileToken = null;
	// 		},
	// 		'expired-callback': () => {
	// 			console.log('Turnstile token expired');
	// 			this.turnstileToken = null;
	// 		}
	// 	});
	// }

	// verifyToken() {
	// 	// call backend to verify token
	// 	this.cloudflareService.verify(this.turnstileToken).subscribe(
	// 		(response) => {
	// 			if (response.success) {
	// 				const verificationData = {
	// 					verified: true,
	// 					timestamp: Date.now()
	// 				};
	// 				localStorage.setItem('turnstileData', JSON.stringify(verificationData));
	// 				this.signInButtonDisabled = false;

	// 			} else {
	// 				this.toastService.showDanger({ content: "Token verification failed" });
	// 			}
	// 		},
	// 		(error) => {
	// 			this.toastService.showDanger({ content: "Token verification failed: " + error.message });
	// 		}
	// 	);
	// }

	doSignIn() {
		this.showFailed = false;
		this.error = undefined;

		if (this.username === undefined) {
			this.toastr.error("Please enter your username");
			return;
		}
		if (this.password === undefined) {
			this.toastr.error("Please enter your password");
			return;
		}

		this.isLoading = true;
		this.authService.signIn(this.username, this.password).subscribe((item: any) => {
			this.password = undefined;

			if (item.error) {
                this.password = undefined;
                this.showFailed = true;
                this.error = item.error.statusText ? item.error.statusText : item.error;
            } else if (item.otpRequired) {
                this.isOtpMode = true;
                this.toastr.info("Please check your email for the verification code.");
            }
			this.isLoading = false;
		});
	}

	doVerifyOtp() {
        this.showFailed = false;
        this.error = undefined;

        if (!this.username) {
            this.toastr.error("Session missing username. Please restart login.");
            this.cancelOtp();
            return;
        }
        
        if (!this.otpCode) {
            this.toastr.error("Please enter the verification code");
            return;
        }

        this.isLoading = true;
        this.authService.verifyOtp(this.username, this.otpCode).subscribe((item: any) => {
            if (item.error) {
                this.showFailed = true;
                this.error = item.error.statusText ? item.error.statusText : item.error;
                this.otpCode = ''; 
            }
            this.isLoading = false;
        });
    }

    cancelOtp() {
        this.isOtpMode = false;
        this.otpCode = '';
        this.password = '';
        this.showFailed = false;
        this.error = undefined;
		this.showOtp = false;
    }

	toggleOtpVisibility() {
        this.showOtp = !this.showOtp;
    }
}
